module.exports = __webpack_public_path__ + "static/media/addToChrome.cc41992b.png";